import React from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";

import logo from "../../assets/images/white-bg-logo.png";

const { useAxios } = require("#api");

const Login = () => {

  const axiosInstance = useAxios();
  
  const onFinish = async (values) => {
    try {
      const response = await axiosInstance.post(`/authphone`, {
        phone: values.number,
        password: values.password,
      });

      if (response.data) {
        localStorage.setItem("token", response.data);
        window.location.href = "/";
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <Form
      name="login"
      initialValues={{
        remember: true,
      }}
      className="mx-auto w-full max-w-md self-center min-h-screen flex flex-col justify-center px-8"
      onFinish={onFinish}
    >
      <div className="flex justify-center mb-8 w-32 mx-auto">
        <img src={logo} alt="logo" />
      </div>
      <Form.Item
        name="number"
        rules={[
          {
            required: true,
            message: "لطفا شماره موبایل خود را وارد کنید",
          },
        ]}
        className="mb-12"
      >
        <Input
          prefix={<UserOutlined />}
          size="large"
          placeholder="شماره موبایل"
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "لطفا رمز عبور خود را وارد کنید",
          },
        ]}
        className="mb-8"
      >
        <Input
          prefix={<LockOutlined />}
          type="password"
          placeholder="رمز عبور"
          size="large"
        />
      </Form.Item>
      <Form.Item>
        <div className="flex justify-between font-yekan items-center">
          
        </div>
      </Form.Item>

      <Form.Item>
        <div className="font-yekan">
          <Button
            block
            type="primary"
            htmlType="submit"
            className="font-yekan mb-4"
            size="large"
          >
            ورود
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
};

export default Login;
